import { render, staticRenderFns } from "./groupProduct.vue?vue&type=template&id=90bc8600&scoped=true"
import script from "./groupProduct.vue?vue&type=script&lang=js"
export * from "./groupProduct.vue?vue&type=script&lang=js"
import style0 from "./groupProduct.vue?vue&type=style&index=0&id=90bc8600&prod&lang=scss&scoped=true"
import style1 from "./groupProduct.vue?vue&type=style&index=1&id=90bc8600&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90bc8600",
  null
  
)

export default component.exports